/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState, useEffect, useCallback } from 'react';
import {
  fetchCardLockStatusRequest,
  updateCardLockStatusRequest,
  useProductName,
  useraccountDetailsRequest,
  renderDescriptionParagraphs,
} from '@rb-serve-app/core';
import CommanModal from './CommanModal';
import { LockedIcon, UnLockedIcon } from '../assets/svg/CardLockedUnlocked';
import {
  MasterCardChip,
  RogersTextICon,
  VerticalCardIcon,
} from '../assets/svg/MasterCardIcons';
import { useDispatch, useSelector } from 'react-redux';
import { EventType, useAnalytics } from '../ui/Analytics';
import Breadcrumbs from './BreadCrumbs';
import Spinner from './Spinner';
import FeatureFlagMessage from './FeatureFlagMessage';
import SuccessModel from './SuccessModel';
import { logBrazeCustomEvent } from '../config/braze';

const LockUnlockCard: React.FC = () => {
  const { trackEvent } = useAnalytics();
  const [verticleCardStatus, setVerticleCardStatus] = useState(true);
  const [cardStatus, setCardStatus] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showFeatureFlagMessage, setShowFeatureFlagMessage] = useState(false);
  const [isError, setIsError] = useState(false);

  const { contentfulData } = useSelector(
    (state: { contentful: any }) => state.contentful
  );
  const { rb_links } = contentfulData.entries;
  const { productName, cardStructure } = useProductName();

  const { entries, assets } = contentfulData;
  const lockUnlockContentFulData = entries?.rb_lock_unlock_card;
  const featureFlaggingData =
    entries?.rb_feature_flagging?.featureFlagging?.manage_card?.lock_unlock_flow
      ?.terms_condition;

  const checkCardType = () => {
    setVerticleCardStatus(true); //for now it is true in future we meed to check vertical or horizontal card type.
  };
  useEffect(() => {
    checkCardType();
  }, []);

  const trackClickEvent = useCallback((name: string) => {
    trackEvent(
      EventType.CLICK_EVENT,
      `${!cardStatus ? 'card is unlocked' : 'card is locked'}`,
      window.location.href,
      `${name}`
    );
  }, []);

  const closeModal = useCallback(() => {
    setIsModalOpen(false);
    trackEvent(
      EventType.CLICK_EVENT,
      `${cardStatus ? 'modal-card successfully locked' : 'modal-card successfully unlocked'}`,
      window.location.href,
      `${
        cardStatus
          ? 'modal-card successfully locked|ok'
          : 'modal-card successfully unlocked|ok'
      }`
    );
  }, [cardStatus]);

  const handleCloseIconClick = useCallback(() => {
    setIsModalOpen(false);
    trackEvent(
      EventType.CLICK_EVENT,
      `${cardStatus ? 'modal-card successfully locked' : 'modal-card successfully unlocked'}`,
      window.location.href,
      `${
        cardStatus
          ? 'modal-card successfully locked|close'
          : 'modal-card successfully unlocked|close'
      }`
    );
  }, [cardStatus]);

  // useEffect(() => {
  //   const handleClickOutside = (event: MouseEvent) => {
  //     const modalElement = document.getElementById('commanModal');
  //     if (modalElement && !modalElement.contains(event.target as Node)) {
  //       closeModal();
  //     }
  //   };
  //   if (isModalOpen) {
  //     document.addEventListener('mousedown', handleClickOutside);
  //   }
  //   return () => {
  //     document.removeEventListener('mousedown', handleClickOutside);
  //   };
  // }, [closeModal, isModalOpen]);

  const {
    status: cardLockStatus,
    loading: isLoading,
    error,
  } = useSelector((state: any) => state.cardLock);

  console.log('error111', isError, error, cardLockStatus);

  const { customerId, accountId, accountDetails } = useSelector(
    (state: any) => state.user
  );
  const dispatch = useDispatch();
  useEffect(() => {
    if (accountId && customerId) {
      dispatch(fetchCardLockStatusRequest({ accountId, customerId }));
    }
  }, [dispatch, accountId, customerId]);

  const cardAuthorizationStatus =
    cardLockStatus?.cardControlPrefData?.cardAuthorizationStatus?.active;

  useEffect(() => {
    if (typeof cardAuthorizationStatus === 'boolean') {
      setCardStatus(cardAuthorizationStatus);
    }
  }, [cardAuthorizationStatus]);

  const [errorDetails, setErrorDetails] = useState({
    title: entries?.rb_error?.genericApiFailure?.header,
    message: entries?.rb_error?.genericApiFailure?.text,
  });

  useEffect(() => {
    if (error !== null) {
      setIsError(true);
    }
  }, [error]);

  const handelErrorClose = () => {
    setIsError(false);
  };

  useEffect(() => {
    trackEvent(
      EventType.PAGE_VIEW,
      `${cardStatus ? 'card is locked' : 'card is unlocked'}`,
      window.location.href
    );
    logBrazeCustomEvent('viewed_lock_unlock_card');
  }, []);

  const handelLockUnlockCard = () => {
    setIsModalOpen(true);
    trackEvent(
      EventType.CLICK_EVENT,
      `${!cardStatus ? 'card is locked' : 'card is unlocked'}`,
      window.location.href,
      `${!cardStatus ? 'card is locked' : 'card is unlocked'}|${!cardStatus ? 'unlock card' : 'lock card'}`,
      false,
      {
        type: 'transaction',
        name: !cardStatus ? 'unlock card' : 'lock card',
      },
      undefined,
      false,
      {},
      false,
      false,
      {},
      true
    );
  };

  const confirmCardLockUnlock = () => {
    logBrazeCustomEvent(
      cardStatus ? 'action_locked_card' : 'action_unlocked_card'
    );

    // Dispatch the update card lock status action only when the confirm button is clicked in the modal
    dispatch(
      updateCardLockStatusRequest({
        accountId,
        customerId,
        status: cardStatus, // Toggle the lock status
      })
    );

    // Update the local lock status after dispatching the action
    //setCardStatus(!cardStatus);
    closeModal(); // Close the confirmation modal
  };

  const ModalContent = () => {
    const popupInfoText = cardStatus
      ? lockUnlockContentFulData?.lockCardPopupInfoText
      : lockUnlockContentFulData?.unlockCardPopupInfoText;

    useEffect(() => {
      if (isModalOpen) {
        trackEvent(
          EventType.PAGE_VIEW,
          cardStatus
            ? 'modal-card successfully locked'
            : 'modal-card successfully unlocked',
          window.location.href,
          undefined,
          true,
          {
            type: 'transaction',
            name: cardStatus ? 'lock card' : 'unlock card',
          }
        );
      }
    }, []);

    return (
      <div className="bg-white flex flex-1 items-center flex-col">
        {!cardStatus ? <UnLockedIcon /> : <LockedIcon />}
        <h2
          id="modal-title"
          className="text-lg font-semibold mt-5"
          aria-label={
            !cardStatus
              ? renderDescriptionParagraphs(
                  lockUnlockContentFulData?.unlockCardPopupTitle,
                  undefined,
                  true
                )
              : renderDescriptionParagraphs(
                  lockUnlockContentFulData?.lockCardPopupTitle,
                  undefined,
                  true
                )
          }
        >
          {!cardStatus
            ? renderDescriptionParagraphs(
                lockUnlockContentFulData?.unlockCardPopupTitle,
                ' '
              )
            : renderDescriptionParagraphs(
                lockUnlockContentFulData?.lockCardPopupTitle,
                ' '
              )}
        </h2>

        <ul
          aria-label="renderDescriptionParagraphs(description,undefined, true)"
          className="list-disc font-normal mt-2 text-[16px] text-gray-700 leading-5 px-5"
        >
          {popupInfoText
            ? Object.entries(popupInfoText).map(
                ([key, item]: [string, any]) => <li key={key}>{item}</li>
              )
            : null}
        </ul>
      </div>
    );
  };

  if (isLoading || !lockUnlockContentFulData) {
    return (
      <div className="flex justify-center items-center h-[70vh]">
        <Spinner />
      </div>
    );
  }

  const cardInfoText = cardStatus
    ? lockUnlockContentFulData.lockCardInfoText
    : lockUnlockContentFulData.unlockCardInfoText;

  const getStatusTitle = () => {
    return !cardStatus
      ? lockUnlockContentFulData?.lockStatusTitle
      : lockUnlockContentFulData?.unlockStatusTitle;
  };

  return (
    <>
      {showFeatureFlagMessage && (
        <FeatureFlagMessage className="md:left-20 left-0" />
      )}
      {isError && (
        <SuccessModel
          isOpen={isError}
          title={errorDetails?.title}
          subTitle={errorDetails?.message}
          successIcon={false}
          closeModal={handelErrorClose}
          errorIcon={false}
        />
      )}
      <div className="bg-[#fafafa] flex flex-col py-4 px-8">
        <Breadcrumbs
          items={[
            {
              name: entries?.rb_manage_card?.manageCardTitle,
              href: '/manage-card',
            },
            {
              name: lockUnlockContentFulData?.lockUnlockCardTitle,
              href: '/lock-unlock',
            },
          ]}
        />
        <div className="bg-white min-h-[70vh] px-[27px] py-[29px] rounded-[15px]">
          <h1
            aria-label={renderDescriptionParagraphs(
              lockUnlockContentFulData?.lockUnlockCardTitle,
              undefined,
              true
            )}
            className="text-text22 font-[650] self-start md:px-4 md:py-0 py-4 px-0 "
          >
            {renderDescriptionParagraphs(
              lockUnlockContentFulData?.lockUnlockCardTitle,
              ' '
            )}
          </h1>
          <div className="bg-white flex md:p-4 py-4 px-0 flex-1 overflow-y-scroll scrollbar-hide gap-8 flex-col lg:flex-row">
            <div
              className="flex flex-col items-center lg:flex-col lg:items-center md:p-6 gap-5 border rounded-[15px] border-gray-200 w-full lg:max-w-[450px] md:flex-row md:items-start md:gap-8 md:justify-start  px-0 py-6 h-max "
              aria-labelledby="card-info"
            >
              <div className={`relative ${!cardStatus && 'opacity-[0.5]'}`}>
                <img
                  src={cardStructure?.imgUrl}
                  alt="Rogers Red World Elite Mastercard"
                  className={
                    cardStructure?.isHorizontal
                      ? `w-[233px] h-[147px]`
                      : `w-[147px] h-[233px] `
                  }
                />
                {!cardStatus && (
                  <span className="absolute inset-0 flex items-center justify-center z-10">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="61"
                      height="60"
                      viewBox="0 0 61 60"
                      fill="none"
                    >
                      <g clipPath="url(#clip0_3765_18494)">
                        <path
                          d="M45.5 20H43V15C43 8.1 37.4 2.5 30.5 2.5C23.6 2.5 18 8.1 18 15V20H15.5C12.75 20 10.5 22.25 10.5 25V50C10.5 52.75 12.75 55 15.5 55H45.5C48.25 55 50.5 52.75 50.5 50V25C50.5 22.25 48.25 20 45.5 20ZM23 15C23 10.85 26.35 7.5 30.5 7.5C34.65 7.5 38 10.85 38 15V20H23V15ZM45.5 50H15.5V25H45.5V50ZM30.5 42.5C33.25 42.5 35.5 40.25 35.5 37.5C35.5 34.75 33.25 32.5 30.5 32.5C27.75 32.5 25.5 34.75 25.5 37.5C25.5 40.25 27.75 42.5 30.5 42.5Z"
                          fill="#666666"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_3765_18494">
                          <rect
                            width="60"
                            height="60"
                            fill="white"
                            transform="translate(0.5)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                  </span>
                )}
                {/* {verticleCardStatus && (
                <>
                  <div
                    className={`absolute top-6 left-[50%] z-20 ${cardStatus && 'opacity-[0.3]'}`}
                  >
                    <MasterCardChip />
                  </div>
                  <div
                    className={`absolute top-2 left-[6%] z-20 ${cardStatus && 'opacity-[0.3]'}`}
                  >
                    <VerticalCardIcon width="50" height="30" />
                  </div>
                  <div
                    className={`absolute top-[87%] left-[8%] z-40 ${cardStatus && 'opacity-[0.1]'}`}
                  >
                    <RogersTextICon />
                  </div>
                </>
              )} */}
              </div>

              <div className=" flex items-center flex-col text-center lg:items-center md:items-baseline md:mt-6 lg:mt-0">
                <h3
                  id="card-info"
                  className="lg:text-lg md:text-[15px] font-normal text-medium"
                >
                  {renderDescriptionParagraphs(productName, ' ')}
                </h3>
                <button
                  className={`flex items-baseline gap-1 justify-center px-5 py-[10px] text-black rounded-full border mt-5 ${
                    !cardStatus
                      ? 'border-primary-red bg-[#FFF6F3] hover:bg-red-100 '
                      : 'border-[#1E8240] bg-[#F4FCF7] hover:bg-green-100'
                  }`}
                >
                  <p
                    className={`inline-block text-sm font-normal ${
                      !cardStatus ? 'text-primary-red' : 'text-[#1E8240]'
                    }`}
                    role="status"
                    aria-live="polite"
                    aria-label={getStatusTitle()}
                  >
                    {getStatusTitle()}
                  </p>
                  <span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="11"
                      height="10"
                      viewBox="0 0 11 10"
                      fill="none"
                    >
                      <circle
                        cx="5.5"
                        cy="5"
                        r="5"
                        fill={`${!cardStatus ? '#DA291C' : '#1E8240'}`}
                      />
                    </svg>
                  </span>
                </button>
              </div>
            </div>

            <div className="flex flex-1 flex-col">
              <div
                className="flex flex-col gap-2 p-6 bg-[#F1FDFF] rounded-lg w-full h-auto"
                aria-labelledby="important-info"
              >
                <h4
                  id="important-info"
                  className="text-lg font-semibold text-gray-800"
                  aria-label={renderDescriptionParagraphs(
                    lockUnlockContentFulData?.lockUnlockPleaseReadTitle,
                    undefined,
                    true
                  )}
                >
                  {renderDescriptionParagraphs(
                    lockUnlockContentFulData?.lockUnlockPleaseReadTitle,
                    ' '
                  )}
                </h4>
                <ul
                  aria-label="description"
                  className="list-disc pl-5 text-gray-700 text-base font-normal leading-10 pb-[30px]"
                >
                  {cardInfoText
                    ? Object.values(cardInfoText).map(
                        (item: any, index: number) => (
                          <li key={index + item?.length}>
                            {renderDescriptionParagraphs(item, ' ')}
                          </li>
                        )
                      )
                    : null}
                </ul>
              </div>

              <div className="flex lg:flex-row lg:justify-between flex-col justify-start items-start mt-4 gap-5 lg:items-center ">
                <p
                  aria-label={`${lockUnlockContentFulData?.termsCondition1Text} ${lockUnlockContentFulData?.termsCondition2Text}`}
                  className="text-base from-normal text-text-black"
                >
                  {lockUnlockContentFulData?.termsCondition1Text}{' '}
                  <a
                    // href="/terms"
                    className={`${featureFlaggingData ? 'text-primary-red' : 'text-gray-300'} cursor-pointer`}
                    onClick={() => {
                      window.open(
                        `${rb_links?.rbLinksCollection.statement_preferences_pdf}`
                      );
                      trackClickEvent(
                        !cardStatus
                          ? 'card is locked|term & conditions'
                          : 'card is unlocked|term & conditions'
                      );
                      if (window.scrollY !== 0) {
                        window.scrollTo({
                          top: 0,
                          behavior: 'smooth',
                        });
                      }
                      // setShowFeatureFlagMessage(true);
                      // setTimeout(() => {
                      //   setShowFeatureFlagMessage(false);
                      // }, 3000);
                    }}
                  >
                    {lockUnlockContentFulData?.termsCondition2Text}
                  </a>
                  .
                </p>
                <button
                  className="bg-primary-red text-white px-5 py-3 hover:bg-red-700 max-h-[60px] w-full max-w-[165px] text-center"
                  aria-label={
                    !cardStatus
                      ? lockUnlockContentFulData?.unlockCardCtaTitle
                      : lockUnlockContentFulData?.lockCardCtaTitle
                  }
                  onClick={() => handelLockUnlockCard()}
                >
                  <p className="text-sm font-[600]">
                    {!cardStatus
                      ? renderDescriptionParagraphs(
                          lockUnlockContentFulData?.unlockCardCtaTitle,
                          ' '
                        )
                      : renderDescriptionParagraphs(
                          lockUnlockContentFulData?.lockCardCtaTitle,
                          ' '
                        )}
                  </p>
                </button>
              </div>
            </div>
          </div>
        </div>
        {/* Modal */}
        {isModalOpen && (
          <CommanModal
            onCloseIconClick={handleCloseIconClick}
            isOpen={isModalOpen}
            onClose={confirmCardLockUnlock}
            cardStatus={cardStatus}
            jsxContent={<ModalContent />}
            buttonText={lockUnlockContentFulData?.popupOkCtaTitle}
          />
        )}
      </div>
    </>
  );
};

export default LockUnlockCard;
